import { Inject, Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { GeneralSeoSettings, GeneralSeoSettingsPayload, GeneralSeoSettingsRecord } from '../../../models/admin/general-seo-settings.model';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { SubmitResponse } from '../../../models';

@Injectable({
  providedIn: 'root'
})
export class GeneralSeoSettingsService extends HttpService<any, GeneralSeoSettings> {

  constructor(http: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(http, apiUrl, apiVersion, 'general-seo-settings');
  }

  getGeneralSeoSettings(page: number = 1, limit: number = 10): Observable<GeneralSeoSettings> {
    return this.getPagedGeneral('general-seo-settings', page, limit);
  }

  deleteGeneralSeoSettings(id: string): Observable<void> {
    return this.delete(id).pipe(map(() => undefined));
  }

  searchGeneralSeoSettings(query: string): Observable<GeneralSeoSettings> {
    return this.searchAllPagedWithQuery(query);
  }

  getGeneralSeoSettingById(id: string): Observable<GeneralSeoSettingsRecord> {
    return this.getById(id) as unknown as Observable<GeneralSeoSettingsRecord>;
  }

  createGeneralSeoSettings(payload: GeneralSeoSettingsPayload): Observable<SubmitResponse> {
    return this.create(payload);
  }

  updateGeneralSeoSettings(id: string, payload: GeneralSeoSettingsPayload): Observable<SubmitResponse> {
    return this.update(payload, id);
  }

  getSEOPageKeys(): Observable<string[]> {
    return this.getAll('page-keys') as unknown as Observable<string[]>;
  }

  getSeoDetailsByPageKey(pageKey: string): Observable<any> {
    return this.getById(pageKey) as unknown as Observable<GeneralSeoSettingsRecord>;
  }
}
